import { Component } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-product-new-arrival-descriptions',
  imports: [],
  templateUrl: './product-new-arrival-descriptions.html',
  styleUrl: './product-new-arrival-descriptions.scss',
})
export class ProductNewArrivalDescriptions {
  get appname(): string {
    return environment.appname;
  }
}
